import { render, staticRenderFns } from "./VueCropperjs.vue?vue&type=template&id=a87a40a4&lang=pug&"
import script from "./VueCropperjs.vue?vue&type=script&lang=js&"
export * from "./VueCropperjs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports